module.exports = __webpack_public_path__ + "static/img/1_2_1_1.3091e985.jpg";